<p-dialog [(visible)]="displayAddEmail" (onHide)="dialogClose()" [modal]="true"
    [responsive]="true" [style]="{ width: '75vw' }">
    <ng-template pTemplate="header">
        <div class="w-100">
            <h5 class="p-mb-0">
                {{ emailAddEditHeader }}
            </h5>
        </div>
    </ng-template>
    <div class="card">
        <form [formGroup]="emailDetailsForm" novalidate>
            <div class="p-grid">
                <div class="p-col-6 p-md-6">
                    <label>Send {{emailTypeName}} From </label>
                    <p-dropdown *ngIf="viewOnly && selectedActionEmail && !selectedActionEmail?.fromUserId && notificationType!=notificationTypeEnum.WHATSAPP" [options]="smtpList" formControlName="from" appendTo="body" placeholder="Select From User" optionLabel="name" [disabled]="viewOnly">
                        <ng-template let-user pTemplate="item">
                            <div class="user-item" [ngClass]="{'inactive-item': user.statusId == 2 }">
                                <div>{{user.name}}</div>
                            </div>
                        </ng-template>
                    </p-dropdown>

                    <p-dropdown [ngClass]="{'p-d-none': notificationType!=notificationTypeEnum.WHATSAPP}" [options]="whatsAppBusinessAccounts" formControlName="whatsappFrom" appendTo="body" placeholder="Select Business Contact" optionLabel="label" [disabled]="viewOnly">
                    </p-dropdown>

                    <p-dropdown [ngClass]="{'p-d-none': ((viewOnly && selectedActionEmail && !selectedActionEmail?.fromUserId) || notificationType==notificationTypeEnum.WHATSAPP)}" [options]="activeUsers" formControlName="fromUserId" optionLabel="name" optionValue="id" placeholder="Send From" appendTo="body" [filter]="true" [autoDisplayFirst]="false" [disabled]="viewOnly">
                        <ng-template let-user pTemplate="selectedItem">
                            <div class="user-item">
                                <div>{{user.name}} ({{user?.emailId}})</div>
                            </div>
                        </ng-template>
                        <ng-template let-user pTemplate="item">
                            <div class="user-item">
                                <div>{{user.name}} ({{user?.emailId}})</div>
                            </div>
                        </ng-template>
                    </p-dropdown>

                    <div *ngIf="detailsFormErrors?.from" class="p-invalid">
                        <small>{{ detailsFormErrors?.from }}</small>
                    </div>
                    <div *ngIf="detailsFormErrors?.whatsappFrom" class="p-invalid">
                        <small>{{ detailsFormErrors?.whatsappFrom }}</small>
                    </div>
                </div>
                <div class="p-col-12 p-md-2">
                    <label>Assign Type <span style="color: red;">*</span></label>
                    <p-dropdown [options]="assignedTypes" (onChange)="selectAssignType(true)" formControlName="assignedType" appendTo="body" placeholder="Select Assing Type" optionLabel="name" [disabled]="viewOnly"></p-dropdown>

                    <div *ngIf="detailsFormErrors?.assignedType" class="p-invalid">
                        <small>{{ detailsFormErrors?.assignedType }}</small>
                    </div>
                </div>
                <div class="p-col-6 p-md-4">
                    <label>Sent To <span style="color: red;">*</span></label>

                    <input *ngIf="![1,7].includes(emailDetailsForm.getRawValue().assignedType?.id)" type="text" [(ngModel)]="defaultEmail"  [ngModelOptions]="{standalone: true}" pInputText placeholder="Default Email" [disabled]="true">

                    <ng-container *ngIf="emailDetailsForm.getRawValue().assignedType?.id==7">
                        <p-multiSelect
                            [options]="contactAssignTypes"
                            optionLabel="name"
                            formControlName="assignedUsers"
                            placeholder="Select Contacts"
                            appendTo="body"
                            [disabled]="viewOnly">
                        </p-multiSelect>

                        <div *ngIf="detailsFormErrors?.assignedUsers" class="p-invalid">
                            <small>Select contacts</small>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="emailDetailsForm.getRawValue().assignedType?.id==1">
                        <liono-treeSelect [disabled]="viewOnly"
                            formControlName="assignedUsers"
                            [options]="activeUserTree"
                            [selectionMode]="'multiple'"
                            [metaKeySelection]="false"
                            [filter]="true"
                            [filterBy]="'name'"
                            filterPlaceholder="Search Users..."
                            appendTo="body" placeholder="Select Users"
                            (onNodeSelect)="onUserSelect($event, 'assignedUsers')">
                            <ng-template let-value pTemplate="selectedItems">
                                <span *ngFor="let selectedCUser of (emailDetailsForm.getRawValue().assignedUsers||[]); let i = index">
                                    {{ (i>0 && i<10)? ',':'' }} {{i<10?selectedCUser?.name: (i==10?'...':'')}}
                                </span>

                                <div *ngIf="!emailDetailsForm.getRawValue().assignedUsers || emailDetailsForm.getRawValue().assignedUsers?.length === 0">
                                    Select Users
                                </div>
                            </ng-template>
                        </liono-treeSelect>

                        <div *ngIf="detailsFormErrors?.assignedUsers" class="p-invalid">
                            <small>{{ detailsFormErrors?.assignedUsers }}</small>
                        </div>
                    </ng-container>

                </div>
                <div class="p-col-6 p-md-6">
                    <label>CC</label>
                    <ng-container >
                        <liono-treeSelect [disabled]="viewOnly"
                            formControlName="assignedUsersCc"
                            [options]="activeUserTree"
                            [selectionMode]="'multiple'"
                            [metaKeySelection]="false"
                            [filter]="true"
                            [filterBy]="'name'"
                            filterPlaceholder="Search Users..."
                            appendTo="body" placeholder="Select Users"
                            (onNodeSelect)="onUserSelect($event, 'assignedUsersCc')">
                            <ng-template let-value pTemplate="selectedItems">
                                <span *ngFor="let selectedCUser of (emailDetailsForm.getRawValue().assignedUsersCc||[]); let i = index">
                                    {{ (i>0 && i<10)? ',':'' }} {{i<10?selectedCUser?.name: (i==10?'...':'')}}
                                </span>

                                <div *ngIf="!emailDetailsForm.getRawValue().assignedUsersCc || emailDetailsForm.getRawValue().assignedUsersCc?.length === 0">
                                    Select Users
                                </div>
                            </ng-template>
                        </liono-treeSelect>
                    </ng-container>

                </div>
                <div class="p-col-6 p-md-6">
                    <label>BCC</label>
                        <liono-treeSelect [disabled]="viewOnly"
                            formControlName="assignedUsersBcc"
                            [options]="activeUserTree"
                            [selectionMode]="'multiple'"
                            [metaKeySelection]="false"
                            [filter]="true"
                            [filterBy]="'name'"
                            filterPlaceholder="Search Users..."
                            appendTo="body" placeholder="Select Users"
                            (onNodeSelect)="onUserSelect($event, 'assignedUsersBcc')">
                            <ng-template let-value pTemplate="selectedItems">
                                <span *ngFor="let selectedCUser of (emailDetailsForm.getRawValue().assignedUsersBcc||[]); let i = index">
                                    {{ (i>0 && i<10)? ',':'' }} {{i<10?selectedCUser?.name: (i==10?'...':'')}}
                                </span>

                                <div *ngIf="!emailDetailsForm.getRawValue().assignedUsersBcc || emailDetailsForm.getRawValue().assignedUsersBcc?.length === 0">
                                    Select Users
                                </div>
                            </ng-template>
                        </liono-treeSelect>
                </div>
            </div>
            <div *ngIf="notificationType!=notificationTypeEnum.WHATSAPP" class="p-grid">
                <!-- <div [ngClass]="{'p-col-12': !emailDetailsForm.getRawValue().emailTemplate,'p-col-6': emailDetailsForm.getRawValue().emailTemplate}"></div> -->
                <div class="p-col-12">
                    <div class="p-grid">
                        <div class="p-col-12">
                            <label>{{emailTypeName}} Template</label>
                            <p-dropdown [options]="emailTemplateList" (onChange)="selectEmailTemplate($event)" formControlName="emailTemplate" appendTo="body" placeholder="Select Template" optionLabel="templateName" [showClear]="true" [filter]="true" [filterBy]="'templateName'" [disabled]="viewOnly"></p-dropdown>

                            <div *ngIf="detailsFormErrors?.emailTemplate" class="p-invalid">
                                <small>{{ detailsFormErrors?.emailTemplate }}</small>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="p-col-3">
                    <div class="p-d-flex align-items-center p-mt-5">
                        <p-checkbox name="isDetailAttached" value="true" [binary]="true"  formControlName="isDetailAttached" [disabled]="viewOnly" inputId="isDetailAttached"></p-checkbox>
                        <label for="isDetailAttached" class="p-ml-2"> Attach Details </label>
                    </div>
                </div> -->
            </div>
            <div class="p-grid">
                <div [ngClass]="{'p-col-9': !viewOnly, 'p-col-12': viewOnly}">
                    <ng-container *ngIf="notificationType!=notificationTypeEnum.WHATSAPP">
                        <label>{{emailTypeName}} Subject <span style="color: red;">*</span></label>
                        <input #emailSubject (focus)="selectedInsertField='subject'" (click)="selectedInsertField='subject'" type="text" formControlName="subject" pInputText placeholder="Enter Subject">

                        <div *ngIf="detailsFormErrors?.subject" class="p-invalid mb-1">
                            <small>{{ detailsFormErrors?.subject }} {{ emailDetailsForm.get('subject')?.errors?.invalidTags }}</small>
                        </div>
                    </ng-container>

                    <label>{{emailTypeName}} Body</label>
                    <p-editor #editor
                        [modules]="editorModules"
                        [ngClass]="{'ql-textonly': notificationType==notificationTypeEnum.WHATSAPP}"
                        (onTextChange)="onEditorTextChange($event)" (onSelectionChange)="selectedInsertField='body'"
                        [(ngModel)]="notificationBody"
                        [ngModelOptions]="{standalone: true}"
                        styleClass="email-template-editor"
                        [readonly]="viewOnly">
                        <p-header>
                            <span class="ql-formats">
                                <select class="ql-size">
                                    <option value="small">small</option>
                                    <option selected></option>
                                    <option value="large">large</option>
                                    <option value="huge">huge</option>
                                </select>
                            </span>
                            <span class="ql-formats">
                                <select class="ql-size">
                                    <option value="24px">24</option>
                                    <option value="48px">48</option>
                                    <option value="100px">100</option>
                                    <option value="200px">200</option>
                                </select>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-bold" aria-label="Bold"></button>
                                <button class="ql-italic" aria-label="Italic"></button>
                                <button class="ql-underline" aria-label="Underline"></button>
                                <button class="ql-strike" aria-label="Strike"></button>
                            </span>
                            <span class="ql-formats">
                                <select title="Text Color" class="ql-color"></select>
                                <span class="ql-format-separator"></span>
                                <select title="Background Color" class="ql-background"></select>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-list" value="ordered"></button>
                                <button class="ql-list" value="bullet"></button>
                                <select title="Text Alignment" class="ql-align">
                                    <option selected>Gauche</option>
                                    <option value="center" label="Center"></option>
                                    <option value="right" label="Right"></option>
                                    <option value="justify" label="Justify"></option>
                                </select>
                            </span>
                            <span class="ql-formats">
                                <button aria-label="Link" class="ql-link"></button>
                                <button aria-label="Image" class="ql-image"></button>
                                <button class="pi pi-table" title="Insert Table" (click)="insertTable()"></button>
                                <span class="btnBars ai-custom" (click)="activityItems.toggle($event)">
                                    <i class="pi ql-ai" [style.background-image]="'url(' + defaultAIImage + ')'"></i>
                                </span>
                                <p-overlayPanel #activityItems styleClass="activityItems custom-ai">
                                    <ng-template pTemplate>
                                      <ul>
                                        <li (click)="showGenerateEmailDialog();activityItems.hide($event)" icon="pi pi-external-link">
                                          <span><i class="pi pi-envelope p-mr-2"></i>Generate Email</span>
                                        </li>
                                      </ul>
                                    </ng-template>
                                </p-overlayPanel>
                            </span>
                        </p-header>
                    </p-editor>

                    <div *ngIf="detailsFormErrors?.body" class="p-invalid">
                        <small>{{ detailsFormErrors?.body }} {{ emailDetailsForm.get('body')?.errors?.invalidTags }}</small>
                    </div>
                </div>
                <div *ngIf="!viewOnly" class="p-col-3">
                    <label>Available Fields</label>
                    <!-- <p-dropdown [options]="modules" formControlName="selectedModule" appendTo="body" placeholder="Select Module" optionLabel="name"></p-dropdown> -->
                    <p-listbox [options]="fieldTypesByGroup" [group]="true" [metaKeySelection]="false" (onChange)="selectTemplateField($event)" optionLabel="name" [filter]="true" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedType" class="available-field-list" [listStyle]="{'max-height':'350px'}">
                        <ng-template let-group pTemplate="group">
                            <div class="listbox-group">
                              <h6 class="p-py-2 p-px-3 p-mb-0">{{group.label}}</h6>
                            </div>
                        </ng-template>
                        <ng-template let-type pTemplate="item">
                            <div class="type-item" [ngClass]="{'type-item-added': addedFieldTags.includes(type.name), 'type-group-item': type?.childGroup, 'type-child-item': type?.childItem}">
                                <div>{{type.name}}</div>
                            </div>
                        </ng-template>
                    </p-listbox>
                </div>
            </div>

            <div class="p-grid">
                <div class="p-col-12">
                    <label>Add Attachments</label>

                    <p-fileUpload customUpload="true" class="fupload" previewWidth="100" chooseLabel="Choose Files" [multiple]="true" [showUploadButton]="false" [showCancelButton]="false" [disabled]="viewOnly"
                        (onSelect)="uploadAttachments($event.files)">
                        <ng-template pTemplate="toolbar">
                            <button *ngIf="addedActiveSavedSearch()?.length==0 && emailDetailsForm.getRawValue().assignedType?.id==1" [disabled]="viewOnly" (click)="newSavedSearchRule()" pButton type="button" class="p-ml-2" label="Attach Saved Search Result" icon="pi pi-plus"></button>
                            <div style="float: right;" [hidden]="!detailsAttachedFor.includes(selectedModule?.objectId)">
                                <div class="p-d-flex">
                                    <p-checkbox name="isDetailAttached" value="true" [binary]="true"  formControlName="isDetailAttached" [disabled]="viewOnly" inputId="isDetailAttached"></p-checkbox>
                                    <label for="isDetailAttached" class="p-ml-2"> Included {{selectedModule?.name}} </label>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="file"></ng-template>
                        <ng-template pTemplate="content">
                            <ng-container *ngIf="emailDetailsForm.getRawValue().assignedType?.id==1">
                                <ng-container *ngFor="let savedSearchDetails of addedSavedSearch;let i=index;">
                                    <ng-container *ngIf="savedSearchDetails.statusId === 1">
                                        <div class="p-fileupload-row">
                                            <button type="button" pButton icon="pi pi-paperclip" class="p-button-link p-px-0 p-py-0" label=""></button>
                                            <div>
                                                <strong>{{ savedSearchDetails?.saveSearchName }} - {{ savedSearchDetails?.objectName }}({{ savedSearchDetails?.channelName }})</strong> <br>
                                                <small>[Saved Search Result will be added as Attachment]</small>
                                            </div>
                                            <div></div>
                                            <div style="width: 100px; max-width: 100px;" *ngIf="!viewOnly">
                                                <button icon="pi pi-pencil" class="p-mr-2" pButton (click)="modifySelectedSavedSearch(savedSearchDetails,i)" type="button"></button>
                                                <button icon="pi pi-times" pButton (click)="removeSavedSearch(savedSearchDetails,i)" type="button"></button>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </ng-container>

                            <ng-container *ngFor="let attachmentDetails of attachments;let i=index;">
                                <ng-container *ngIf="attachmentDetails.statusId === 1">
                                    <div class="p-fileupload-row">
                                        <button type="button" pButton icon="fa fa-download"
                                            (click)="downloadFile(attachmentDetails.displayFileName, attachmentDetails?.attachment?.content, attachmentDetails?.oldAttachment?.id)"
                                            class="p-button-link p-px-0 p-py-0" label="">
                                        </button>
                                        <div [ngClass]="{'p-fileupload-link': !!(attachmentDetails?.oldAttachment?.id>0)}">
                                            <ng-container *ngIf="attachmentDetails.displayFileName.length>50 else splitImageName">
                                                <div (click)="openFileNewTab(attachmentDetails?.oldAttachment)">{{ attachmentDetails.displayFileName.substring(0, 50) }}...</div>
                                            </ng-container>
                                            <ng-template #splitImageName>
                                                <div (click)="openFileNewTab(attachmentDetails?.oldAttachment)">{{ attachmentDetails.displayFileName }}</div>
                                            </ng-template>
                                        </div>

                                        <div style="width: 100px; max-width: 100px;">{{ (attachmentDetails.fileSize / 1024).toFixed(2) + ' KB' }}</div>
                                        <div style="width: 100px; max-width: 100px;" *ngIf="!viewOnly">
                                            <button icon="pi pi-times" pButton (click)="removeAttachment(attachmentDetails,i)" type="button"></button>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                        </ng-template>
                    </p-fileUpload>


                </div>
            </div>
        </form>
    </div>
    <p-footer>
        <button type="button" pButton (click)="dialogClose()" label="Cancel" class="p-button-secondary"></button>
        <button *ngIf="!viewOnly" type="submit" pButton (click)="saveEmail()" label="Save"></button>
    </p-footer>
</p-dialog>

<!-- File Opener Modal -->
<app-shared-file-opener
    *ngIf="displayFilePreview"
    [directLink]="true"
    [modalDisplay]="displayFilePreview"
    [modalFile]="currentFile"
    (closeFilePreview)="closeFilePreview()">
</app-shared-file-opener>

<!-- Saved Search Rules Add -->
<app-workflow-add-saved-search-rules
    *ngIf="displaySavedSearchRule"
    [displaySavedSearchRule]="displaySavedSearchRule"
    [headerTitle]="'Select Saved Search'"
    [moduleSelection]="true"
    [parentModules]="parentModules"
    [parentTemplates]="parentTemplates"
    [selectedParentModule]="selectedModule"
    [selectedParentTemplate]="{channelId: selectedChannelId}"
    [selectedSavedSearch]="selectedSavedSearch"
    (dialogClosed)="closeSavedSearchRulesDialog()"
    (savedSearchRulesAdded)="addSavedSearchRules($event)"
></app-workflow-add-saved-search-rules>

<app-email-generate-ai *ngIf="visibleEmailGenerationScenario"
    [displayDialog]="visibleEmailGenerationScenario"
    (emailGenerated)="setGeneratedEmail($event)"
    (dialogClose)="closeGenerateDialog()">
</app-email-generate-ai>
